import { Alert } from '@winnin/winnin_ui.components.alert'
import { Button } from '@winnin/winnin_ui.components.button'
import { Checkbox } from '@winnin/winnin_ui.components.checkbox'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { MODAL_STYLE } from './create-niche-dashboard-modal.consts'
import { translations } from './create-niche-dashboard-modal.i18n'
import type { ICreateNicheDashboardModalView } from './create-niche-dashboard-modal.types'
import { NICHE_LIMIT, NICHE_MIN_LIMIT } from '../common/niche.consts'
import './create-niche-dashboard-modal.styles.scss'

export const CreateNicheDashboardModalView = ({
  isOpen,
  territoryName,
  handleSelectNiche,
  contextName,
  inputValue,
  onInputChange,
  handleCreateReport,
  isSubmitEnabled,
  showNicheMinLimitAlert,
  nicheListWithActive,
  handleCancel,
}: ICreateNicheDashboardModalView) => {
  const t = useTranslate()

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCancel}
      appElement={document.querySelector('.ThemeProvider')}
      style={MODAL_STYLE}
    >
      <div className="CreateNicheDashboardModal">
        <div className="CreateNicheDashboardModal-titleSection">
          <Title tag="h3">{t(translations.title)}</Title>
          <p className="CreateNicheDashboardModal-description">{t(translations.description)}</p>
        </div>
        <div className="CreateNicheDashboardModal-inputSection">
          <InputWithLabel
            name="report-title"
            id="report-title"
            onChange={onInputChange}
            value={inputValue}
            label={t(translations.textLabel)}
            placeholder={t(translations.textLabel)}
          />
        </div>
        <Alert variation="info" message={t(translations.nicheLimitMessage(NICHE_LIMIT)) as string} />
        <div className="CreateNicheDashboardModal-listSection">
          <p className="CreateNicheDashboardModal-dashboardType">
            {territoryName}: {contextName}
          </p>
          <div className="CreateNicheDashboardModal-nicheList">
            {nicheListWithActive.map(item => {
              return (
                <div key={item.id}>
                  <Checkbox
                    isActive={item.isActive}
                    handleClick={() => {
                      handleSelectNiche(item.id)
                    }}
                  >
                    {item.name}
                  </Checkbox>
                </div>
              )
            })}
          </div>
        </div>

        {showNicheMinLimitAlert && (
          <Alert variation="warning" message={t(translations.nicheMinLimitMessage(NICHE_MIN_LIMIT)) as string} />
        )}

        <div className="CreateNicheDashboardModal-buttonsSection">
          <Button onClick={handleCancel} appearance="link">
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button onClick={handleCreateReport} disabled={!isSubmitEnabled}>
            {t(TOLGEE_GLOBALS.create)}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
